import React, { useState, useEffect } from "react";
import { Link} from "react-router-dom";
import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaChevronLeft, FaShare, FaLinkedin, FaTwitter, FaFacebook, FaTicketAlt, FaUserTie } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Données des événements (normalement ceci serait importé d'un autre fichier)
const EventsData = [
  {
    id: 1,
    title: "Webinaire: Préparer sa clôture comptable 2025",
    description: "Découvrez les meilleures pratiques pour une clôture comptable réussie avec nos experts-comptables.",
    date: "15 Mai 2025",
    time: "14:30 - 16:00",
    location: "En ligne",
    type: "Webinaire",
    image: "/assets/images/webinar-image.jpg",
    featured: true,
    registrationLink: "#inscription-webinaire",
    speakers: [
      { name: "Marie Laurent", role: "Expert-comptable", image: "/assets/images/speaker1.jpg" }
    ],
    // Contenu détaillé de l'événement (ajouté pour la page de détail)
    content: `
      <p class="lead">Préparez efficacement votre clôture comptable 2025 grâce à ce webinaire exclusif animé par nos experts-comptables. Obtenez des conseils pratiques et des astuces pour optimiser ce processus crucial pour votre entreprise.</p>
      
      <h3>1. Pourquoi participer à ce webinaire ?</h3>
      <p>La clôture comptable est une étape fondamentale dans la vie d'une entreprise. Elle permet non seulement de répondre aux obligations légales, mais aussi d'obtenir une vision claire de la situation financière de votre société. Ce webinaire vous fournira toutes les clés pour aborder sereinement cette étape.</p>
      
      <p>Notre experte, Marie Laurent, vous guidera à travers les bonnes pratiques et vous alertera sur les pièges à éviter, vous permettant ainsi de gagner du temps et d'optimiser vos processus.</p>
      
      <h3>2. Programme du webinaire</h3>
      <p>Durant cette session d'1h30, nous aborderons les thématiques suivantes :</p>
      <ul>
        <li>Préparation en amont : les documents à rassembler</li>
        <li>Les étapes clés d'une clôture réussie</li>
        <li>Comment traiter les opérations d'inventaire</li>
        <li>Nouvelles règles fiscales applicables en 2025</li>
        <li>Outils et logiciels pour faciliter le processus</li>
        <li>Session de questions-réponses</li>
      </ul>
      
      <blockquote>
        "Une clôture comptable bien préparée est la garantie d'une vision financière claire et d'une conformité optimale. Ce webinaire vous donnera tous les outils pour y parvenir efficacement." - Marie Laurent
      </blockquote>
      
      <h3>3. À qui s'adresse ce webinaire ?</h3>
      <p>Ce webinaire est destiné aux :</p>
      <ul>
        <li>Dirigeants de TPE/PME</li>
        <li>Responsables administratifs et financiers</li>
        <li>Comptables d'entreprise</li>
        <li>Gestionnaires de cabinet d'expertise comptable</li>
      </ul>
      
      <p>Aucun prérequis technique n'est nécessaire pour participer à cette session en ligne. Une connaissance basique des principes comptables est toutefois recommandée.</p>
      
      <h3>4. Informations pratiques</h3>
      <p>Le webinaire se déroulera sur notre plateforme sécurisée. Un lien de connexion vous sera envoyé par email après votre inscription. Vous pourrez poser vos questions en direct via le chat et un enregistrement sera disponible pour les participants pendant 30 jours après l'événement.</p>
      
      <p>Ne manquez pas cette opportunité d'optimiser votre processus de clôture comptable et de bénéficier des conseils de nos experts !</p>
    `,
    // Tags ajoutés pour la cohérence avec le modèle d'article
    tags: ["Comptabilité", "Clôture", "Webinaire", "Formation", "Expert-comptable"]
  },
  {
    id: 2,
    title: "Formation: Optimisation fiscale pour PME",
    description: "Une journée complète pour comprendre et mettre en place une stratégie d'optimisation fiscale adaptée à votre PME.",
    date: "22 Mai 2025",
    time: "09:00 - 17:00",
    location: "CINEF-EC Paris",
    type: "Formation",
    image: "/assets/images/formation-image.jpg",
    featured: true,
    registrationLink: "#inscription-formation",
    speakers: [
      { name: "Jean Dupont", role: "Fiscaliste", image: "/assets/images/speaker2.jpg" },
      { name: "Sophie Benoit", role: "Expert-comptable", image: "/assets/images/speaker3.jpg" }
    ],
    content: `
      <p class="lead">Cette formation d'une journée complète vous permettra de maîtriser les techniques d'optimisation fiscale légales et adaptées aux PME.</p>
      
      <h3>1. Objectifs de la formation</h3>
      <p>À l'issue de cette formation, vous serez capable de :</p>
      <ul>
        <li>Identifier les dispositifs fiscaux avantageux pour votre structure</li>
        <li>Mettre en place une stratégie fiscale optimisée</li>
        <li>Anticiper les changements législatifs</li>
        <li>Sécuriser vos pratiques face au risque de redressement</li>
      </ul>
      
      <h3>2. Programme de la journée</h3>
      <p>La formation se déroulera en quatre modules distincts :</p>
      <ul>
        <li>Module 1 : Les fondamentaux de la fiscalité des PME</li>
        <li>Module 2 : Optimisation de l'IS et dispositifs incitatifs</li>
        <li>Module 3 : Fiscalité du dirigeant et stratégies de rémunération</li>
        <li>Module 4 : Cas pratiques et mise en application</li>
      </ul>
      
      <h3>3. Méthodes pédagogiques</h3>
      <p>Cette formation privilégie une approche interactive avec :</p>
      <ul>
        <li>Apports théoriques et conceptuels</li>
        <li>Études de cas concrets</li>
        <li>Ateliers pratiques en sous-groupes</li>
        <li>Échanges d'expériences entre participants</li>
      </ul>
      
      <h3>4. Public cible</h3>
      <p>Cette formation s'adresse aux :</p>
      <ul>
        <li>Dirigeants et managers de PME</li>
        <li>Responsables comptables et financiers</li>
        <li>Conseillers d'entreprise</li>
      </ul>
    `,
    tags: ["Fiscalité", "Formation", "PME", "Optimisation", "Expert-comptable"]
  },
  {
    id: 7,
    title: "Webinaire: Déclaration sociale des indépendants",
    description: "Guide complet pour vous aider à remplir correctement votre DSI et éviter les erreurs courantes.",
    date: "2 Juillet 2025",
    time: "11:00 - 12:30",
    location: "En ligne",
    type: "Webinaire",
    image: "/assets/images/webinar-dsi-image.jpg",
    featured: false,
    registrationLink: "#inscription-webinaire-dsi",
    speakers: [
      { name: "Marie Laurent", role: "Expert-comptable", image: "/assets/images/speaker1.jpg" }
    ],
    content: `
      <p class="lead">Ce webinaire vous guide pas à pas dans la préparation et la soumission de votre Déclaration Sociale des Indépendants (DSI).</p>
      
      <h3>1. Enjeux de la DSI</h3>
      <p>La Déclaration Sociale des Indépendants est un document essentiel qui détermine le montant de vos cotisations sociales. Une déclaration incorrecte peut entraîner :</p>
      <ul>
        <li>Un paiement excessif de cotisations</li>
        <li>Des régularisations importantes</li>
        <li>Des pénalités en cas d'erreur ou de retard</li>
      </ul>
      
      <h3>2. Points clés abordés</h3>
      <p>Ce webinaire vous expliquera en détail :</p>
      <ul>
        <li>Le calendrier et les échéances à respecter</li>
        <li>Les revenus à déclarer selon votre statut</li>
        <li>Les déductions possibles</li>
        <li>La répartition entre revenus professionnels et revenus de remplacement</li>
        <li>Les pièges à éviter lors de la déclaration</li>
      </ul>
      
      <h3>3. Démonstration pratique</h3>
      <p>Notre experte vous montrera en direct comment remplir votre DSI en ligne, en expliquant chaque rubrique et en vous donnant des conseils personnalisés.</p>
    `,
    tags: ["DSI", "Indépendants", "Webinaire", "Déclaration", "Social"]
  }
];

const DetailEvent = () => {

  // Plus besoin d'utiliser useParams() puisque vous voulez toujours l'événement avec ID 1
  // const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [similarEvents, setSimilarEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simuler un chargement de données
    setLoading(true);

    // Utiliser directement l'ID 1 au lieu de l'extraire de l'URL
    const eventId = 1;
    const foundEvent = EventsData.find(e => e.id === eventId);

    if (foundEvent) {
      setEvent(foundEvent);

      // Trouver des événements similaires (même type ou événements à venir)
      const similar = EventsData
        .filter(e => e.id !== eventId && (e.type === foundEvent.type || new Date(e.date) > new Date()))
        .slice(0, 2); // Limiter à 2 événements similaires

      setSimilarEvents(similar);
    }

    setLoading(false);
  },
    []); // Plus besoin de "id" dans le tableau de dépendances

  // Afficher un message de chargement pendant le chargement des données
  if (loading) {
    return (
      <>
        <Header />
        <div className="container py-5 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
          <p className="mt-3">Chargement de l'événement...</p>
        </div>
        <Footer />
      </>
    );
  }

  // Afficher un message si l'événement n'est pas trouvé
  if (!event) {
    return (
      <>
        <Header />
        <div className="container py-5 text-center">
          <div className="alert alert-warning" role="alert">
            <h4 className="alert-heading">Événement non trouvé</h4>
            <p>Désolé, l'événement que vous recherchez n'existe pas ou a été supprimé.</p>
            <hr />
            <Link to="/evenements" className="btn btn-primary">
              Voir tous les événements
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <div className="event-content py-5">
        <div className="container">
          {/* Fil d'Ariane */}
          <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">Accueil</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/evenements" className="text-decoration-none">Événements</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {event.title}
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              {/* Type et Titre */}
              <div className="event-header mb-4">
                <span className="type-badge">{event.type}</span>
                <h1 className="event-title mt-3">{event.title}</h1>

                {/* Métadonnées de l'événement */}
                <div className="event-meta d-flex flex-wrap align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{event.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{event.time}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaMapMarkerAlt className="meta-icon" />
                    <span>{event.location}</span>
                  </div>
                </div>
              </div>

              {/* Image principale */}
              <div className="event-featured-image mb-4">
                {/* Utilisation d'une image par défaut pour le test */}
                <img
                  src={event.image || "../assets/images/image1.png"}
                  alt={event.title}
                  className="img-fluid rounded"
                  onError={(e) => {
                    e.target.src = "../assets/images/image2.png";
                  }}
                />
              </div>

              {/* Description de l'événement */}
              <div className="event-excerpt mb-4">
                <p className="lead">{event.description}</p>
              </div>

              {/* Contenu principal */}
              <div className="event-body mb-5" dangerouslySetInnerHTML={{ __html: event.content }} />

              {/* Bouton d'inscription */}
              <div className="registration-section mb-5">
                <a href={event.registrationLink} className="btn btn-registration">
                  <FaTicketAlt className="me-2" /> S'inscrire à cet événement
                </a>
              </div>

              {/* Tags */}
              {event.tags && (
                <div className="event-tags mb-4">
                  {event.tags.map((tag, index) => (
                    <Link key={index} to={`/tag/${tag}`} className="event-tag">
                      #{tag}
                    </Link>
                  ))}
                </div>
              )}

              {/* Partage sur les réseaux sociaux */}
              <div className="event-share mb-5">
                <h5 className="share-title">Partager cet événement</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              {/* Bouton Retour */}
              <div className="event-actions mb-5">
                <Link to="/actualites/events" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour aux événements
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              {/* Informations sur l'événement */}
              <div className="sidebar-widget event-info-widget">
                <h4 className="widget-title">Informations pratiques</h4>
                <ul className="event-info-list">
                  <li className="event-info-item">
                    <div className="info-icon">
                      <FaCalendarAlt />
                    </div>
                    <div className="info-content">
                      <h5>Date</h5>
                      <p>{event.date}</p>
                    </div>
                  </li>
                  <li className="event-info-item">
                    <div className="info-icon">
                      <FaClock />
                    </div>
                    <div className="info-content">
                      <h5>Horaires</h5>
                      <p>{event.time}</p>
                    </div>
                  </li>
                  <li className="event-info-item">
                    <div className="info-icon">
                      <FaMapMarkerAlt />
                    </div>
                    <div className="info-content">
                      <h5>Lieu</h5>
                      <p>{event.location}</p>
                    </div>
                  </li>
                </ul>
                <a href={event.registrationLink} className="btn btn-primary w-100 mt-3">
                  <FaTicketAlt className="me-2" /> S'inscrire maintenant
                </a>
              </div>

              {/* Intervenants */}
              {event.speakers && event.speakers.length > 0 && (
                <div className="sidebar-widget speakers-widget">
                  <h4 className="widget-title">Intervenant{event.speakers.length > 1 ? 's' : ''}</h4>
                  <div className="speakers-list">
                    {event.speakers.map((speaker, index) => (
                      <div key={index} className="speaker-profile">
                        <div className="speaker-image">
                          <img
                            src={speaker.image || "../assets/images/image3.png"}
                            alt={speaker.name}
                            className="img-fluid rounded-circle"
                            onError={(e) => {
                              e.target.src = "../assets/images/image3.png";
                            }}
                          />
                        </div>
                        <div className="speaker-info">
                          <h5 className="speaker-name">{speaker.name}</h5>
                          <p className="speaker-role">
                            <FaUserTie className="me-2" size={14} />
                            {speaker.role}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Événements similaires */}
              {similarEvents.length > 0 && (
                <div className="sidebar-widget similar-events-widget">
                  <h4 className="widget-title">Événements similaires</h4>
                  <div className="similar-events">
                    {similarEvents.map((similarEvent) => (
                      <Link key={similarEvent.id} to={`/evenements/${similarEvent.id}`} className="similar-event">
                        <div className="similar-event-image">
                          <img
                            src={similarEvent.image || "../assets/images/image5.png"}
                            alt={similarEvent.title}
                            className="img-fluid rounded"
                            onError={(e) => {
                              e.target.src = "../assets/images/image5.png";
                            }}
                          />
                          <span className="type-badge small">{similarEvent.type}</span>
                        </div>
                        <div className="similar-event-content">
                          <h5 className="similar-event-title">{similarEvent.title}</h5>
                          <div className="similar-event-date">
                            <FaCalendarAlt className="me-1" size={12} />
                            <small>{similarEvent.date}</small>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}

              {/* Widget Rappel */}
              <div className="sidebar-widget reminder-widget">
                <h4 className="widget-title">Recevoir un rappel</h4>
                <p className="reminder-desc">Ne manquez pas cet événement ! Inscrivez-vous pour recevoir un rappel par email</p>
                <form className="reminder-form">
                  <div className="form-group mb-3">
                    <input type="email" className="form-control" placeholder="Votre adresse email" required />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">Activer le rappel</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        /* Styles généraux */
        .event-content {
          background-color: #f8f9fa;
        }

        /* Fil d'Ariane */
        .breadcrumb {
          background-color: transparent;
          padding: 0;
          margin-bottom: 0;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #6c757d;
        }

        .breadcrumb-item a {
          color: #6c757d;
          text-decoration: none;
        }

        .breadcrumb-item.active {
          color: #212529;
          font-weight: 500;
        }

        /* En-tête de l'événement */
        .event-header {
          margin-bottom: 2rem;
        }

        .event-title {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.2;
        }

        .type-badge {
          display: inline-block;
          background: linear-gradient(to right, #198754, #dc3545);
          color: white;
          padding: 6px 15px;
          border-radius: 30px;
          font-size: 14px;
          font-weight: 600;
        }

        .event-meta {
          color: #6c757d;
          font-size: 14px;
          gap: 20px;
        }

        .meta-item {
          gap: 5px;
          margin-right: 20px;
          margin-bottom: 10px;
        }

        .meta-icon {
          font-size: 14px;
          margin-right: 5px;
        }

        /* Image principale */
        .event-featured-image {
          border-radius: 8px;
          
        }

        /* Description */
        .event-excerpt .lead {
          font-size: 1.25rem;
          font-weight: 300;
          line-height: 1.6;
          color: #495057;
        }

        /* Contenu de l'événement */
        .event-body {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #212529;
        }

        .event-body h3 {
          margin-top: 2rem;
          margin-bottom: 1rem;
          font-weight: 700;
          color: #212529;
        }

        .event-body p {
          margin-bottom: 1.5rem;
        }

        .event-body ul {
          margin-bottom: 1.5rem;
          padding-left: 1.5rem;
        }

        .event-body ul li {
          margin-bottom: 0.5rem;
        }

        .event-body blockquote {
          border-left: 4px solid #198754;
          padding-left: 1.5rem;
          font-style: italic;
          margin: 2rem 0;
          color: #495057;
        }

        /* Bouton d'inscription */
        .btn-registration {
          display: inline-flex;
          align-items: center;
          background: linear-gradient(to right, #198754, #dc3545);
          color: white;
          padding: 12px 25px;
          border-radius: 30px;
          text-decoration: none;
          font-weight: 600;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          border: none;
        }

        .btn-registration:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          opacity: 0.9;
          color: white;
        }

        /* Tags */
        .event-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 2rem;
        }

        .event-tag {
          display: inline-block;
          background-color: #e9ecef;
          color: #495057;
          padding: 5px 12px;
          border-radius: 20px;
          text-decoration: none;
          font-size: 13px;
          transition: all 0.3s ease;
        }

        .event-tag:hover {
          background-color: #198754;
          color: white;
        }

        /* Partage social */
        .event-share {
          margin-top: 2rem;
          padding-top: 1.5rem;
          border-top: 1px solid #dee2e6;
        }

        .share-title {
          font-size: 1rem;
          margin-bottom: 1rem;
          color: #495057;
        }

        .social-buttons {
          display: flex;
          gap: 15px;
        }

        .social-button {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: transform 0.3s ease;
        }

        .social-button:hover {
          transform: translateY(-3px);
        }

        .linkedin {
          background-color: #0077B5;
        }

        .twitter {
          background-color: #1DA1F2;
        }

        .facebook {
          background-color: #4267B2;
        }

        /* Bouton retour */
        .btn-back {
          display: inline-flex;
          align-items: center;
          background-color: white;
          color: #495057;
          padding: 10px 20px;
          border-radius: 30px;
          text-decoration: none;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .btn-back:hover {
          background-color: #f8f9fa;
          transform: translateX(-5px);
        }

        /* Sidebar Widgets */
        .sidebar-widget {
          background-color: white;
          border-radius: 8px;
          padding: 25px;
          margin-bottom: 30px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
        }

        .widget-title {
          font-size: 1.25rem;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #f0f0f0;
          position: relative;
        }

        .widget-title:after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 2px;
          background: linear-gradient(to right, #198754, #dc3545);
        }

        /* Widget Informations */
        .event-info-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .event-info-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 20px;
        }

        .info-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(to right, #198754, #dc3545);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          margin-right: 15px;
          flex-shrink: 0;
        }

        .info-content h5 {
          font-size: 16px;
          margin-bottom: 5px;
          color: #495057;
        }

        .info-content p {
          margin-bottom: 0;
          color: #212529;
          font-weight: 500;
        }

        /* Widget Intervenants */
        .speakers-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .speaker-profile {
          display: flex;
          align-items: center;
        }

        .speaker-image {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 15px;
          flex-shrink: 0;
          border: 3px solid #f8f9fa;
        }

        .speaker-name {
          font-size: 18px;
          margin-bottom: 5px;
        }

        .speaker-role {
          font-size: 14px;
          color: #6c757d;
          margin-bottom: 0;
          display: flex;
          align-items: center;
        }

        /* Widget Événements similaires */
        .similar-events {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .similar-event {
          display: flex;
          text-decoration: none;
          color: inherit;
          background-color: #f8f9fa;
          border-radius: 8px;
          overflow: hidden;
          transition: transform 0.3s ease;
        }

        .similar-event:hover {
          transform: translateY(-3px);
        }

        .similar-event-image {
          width: 100px;
          height: 70px;
          flex-shrink: 0;
          position: relative;
        }

        .similar-event-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .similar-event-image .type-badge {
          position: absolute;
          top: 5px;
          left: 5px;
          padding: 2px 8px;
          font-size: 10px;
        }

        .similar-event-content {
          padding: 10px;
        }

        .similar-event-title {
          font-size: 15px;
          margin-bottom: 5px;
          line-height: 1.3;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .similar-event-date {
          font-size: 12px;
          color: #6c757d;
          display: flex;
          align-items: center;
        }

        /* Widget Rappel */
        .reminder-desc {
          margin-bottom: 15px;
          color: #6c757d;
          font-size: 14px;
        }

        .btn-primary {
         background: linear-gradient(to right, #198754, #dc3545);
         border: none;
         border-radius: 30px;
         padding: 10px 20px; /* largeur réduite ici */
         font-weight: 500;
         transition: all 0.3s ease;
        }


        .btn-primary:hover {
          opacity: 0.9;
          transform: translateY(-2px);
        }

        /* Responsive */
        @media (max-width: 992px) {
          .event-title {
            font-size: 2rem;
          }
        }

        @media (max-width: 768px) {
          .event-title {
            font-size: 1.8rem;
          }
          
          .event-meta {
            flex-wrap: wrap;
          }
          
          .similar-event-image {
            width: 80px;
            height: 60px;
          }
          
          .similar-event-title {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

export default DetailEvent;